const FOLLOW_UP_PUBLIC_SUBMISSION_STATUSES = [
    'awaiting_documentation',
    'documentation_submitted',
    'attached_participant'
];

const LEGACY_PUBLIC_SUBMISSION_STATUSES = [
    'new',
    'reviewed',
    'created_participant',
    'hidden'
];

const isFollowUpPublicSubmissionStatus = (status: string) =>
    FOLLOW_UP_PUBLIC_SUBMISSION_STATUSES.includes(status);

const filterPublicSubmissionStatusItems = <T extends { status: string }>(
    items: T[],
    followUpsEnabled: boolean
): T[] => followUpsEnabled
    ? items
    : items.filter(item => !isFollowUpPublicSubmissionStatus(item.status));

const getPublicSubmissionRequestFilters = (
    filters: string[],
    followUpsEnabled: boolean
): string[] => {
    if (followUpsEnabled) {
        return filters;
    }

    const legacyFilters = filters.filter(filter => !isFollowUpPublicSubmissionStatus(filter));
    return legacyFilters.length > 0 ? legacyFilters : LEGACY_PUBLIC_SUBMISSION_STATUSES;
};

const getPublicSubmissionFilteredOutCount = (
    summaries: { status: string; allTimeCount: number; filteredCount: number }[],
    followUpsEnabled: boolean
): number => filterPublicSubmissionStatusItems(summaries, followUpsEnabled)
    .filter(summary => summary.status !== 'hidden')
    .reduce(
        (total, summary) => total + summary.allTimeCount - summary.filteredCount,
        0
    );

const getActionablePublicSubmissionCount = (
    summaries: { status: string; allTimeCount: number }[],
    followUpsEnabled: boolean
): number => {
    const actionableStatuses = followUpsEnabled
        ? ['new', 'documentation_submitted']
        : ['new'];
    return summaries
        .filter(summary => actionableStatuses.includes(summary.status))
        .reduce((total, summary) => total + summary.allTimeCount, 0);
};

export {
    filterPublicSubmissionStatusItems,
    getActionablePublicSubmissionCount,
    getPublicSubmissionFilteredOutCount,
    getPublicSubmissionRequestFilters,
    isFollowUpPublicSubmissionStatus
};
